import React, { useState, useMemo } from 'react';
import { ErrorText } from '../libCategoria';
import { usePatientsDropdown } from '../../hooks/usePatientsDropdown';
import ReactSelect from 'react-select';

const SelectPatient = React.forwardRef((props, ref) => {
    const { name, label, defaultValue, error, onChange, ...rest } = props;
    const { patients, loading } = usePatientsDropdown();
    const [value, setValue] = useState(defaultValue || '');

    const options = useMemo(() =>
        patients.map((p) => ({
            value: p.id,
            label: `${p.lastname} ${p.firstname} - ${p.dni}`
        })),
        [patients]
    );

    const selectedOption = useMemo(() =>
        options.find(o => String(o.value) === String(value)) || null,
        [options, value]
    );

    const handleSelectChange = (selected) => {
        const newValue = selected ? selected.value : '';
        setValue(newValue);
        if (onChange) {
            onChange({ target: { name, value: newValue } });
        }
    };

    return (
        <div>
            {label && <label style={{ display: 'block', fontSize: '.9rem', color: '#6c757d', marginBottom: '4px' }}>{label}</label>}
            <ReactSelect
                name={name}
                ref={ref}
                options={options}
                value={selectedOption}
                onChange={handleSelectChange}
                placeholder="Buscar paciente..."
                noOptionsMessage={() => "Sin resultados"}
                loadingMessage={() => "Cargando..."}
                isLoading={loading}
                isClearable
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                    control: (base) => ({
                        ...base,
                        fontSize: '0.9rem',
                        minHeight: '38px',
                    }),
                    option: (base) => ({
                        ...base,
                        fontSize: '0.9rem',
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 1500,
                    }),
                }}
                {...rest}
            />
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    );
});

export default SelectPatient;
